import _regeneratorRuntime from "/root/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(cancelOnLocationChange);

import { take, call, all } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';
/**
 * Saga that ejects all of the sagas for the provided keys on location change
 * @type {Saga}
 * @param {Function} ejectSaga - Function that ejects a saga from the store
 * @param {Array<Symbol>} sagaKeys - Keys for the sagas to eject
 */

export function cancelOnLocationChange(ejectSaga, sagaKeys) {
  return _regeneratorRuntime.wrap(function cancelOnLocationChange$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return take(LOCATION_CHANGE);

        case 2:
          _context.next = 4;
          return all(sagaKeys.map(function (key) {
            return call(ejectSaga, key);
          }));

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}